<template>
  <div class="list-card" @click="changeListCategory(listCategoryName)">
    <font-awesome-icon class="template-icon" :icon="icon"/>
    <h1 class="template-name">{{ listCategoryName }}</h1>
    <p class="template-description">{{ listCategoryDescription }}</p>
  </div>
</template>

<script>
  import router from "../../router";

  export default {
    name: "ListCategoryCard",
    props: {
      icon: String,
      listCategoryName: String,
      listCategoryDescription: String
    },
    methods: {
      changeListCategory(listCategoryName) {
        if (listCategoryName === 'Inbox') {
          this.$store.dispatch('updateListCategory', 'inbox')
          router.push('./inbox')
        } else if (listCategoryName === 'Important') {
          this.$store.dispatch('updateListCategory', 'important')
          router.push('./important')
        } else if (listCategoryName === 'Today') {
          this.$store.dispatch('updateListCategory', 'today')
          router.push('./today')
        } else if (listCategoryName === 'Assigned') {
          this.$store.dispatch('updateListCategory', 'assigned')
          router.push('./assigned')
        } else if (listCategoryName === 'Planned') {
          this.$store.dispatch('updateListCategory', 'planned')
          router.push('./planned')
        } else if (listCategoryName === 'Overdue') {
          this.$store.dispatch('updateListCategory', 'overdue')
          router.push('./overdue')
        } else if (listCategoryName === 'Personal List') {
          this.$store.dispatch('updateListCategory', 'personalList')
          router.push('./personalList')
        } else if (listCategoryName === 'Collaborative List') {
          this.$store.dispatch('updateListCategory', 'collaborativeList')
          router.push('./collaborativeList')
        }
      }
    }
  }
</script>

<style scoped>
  .list-card {
    border: 1px solid #212441;
    padding: 1em;
  }

  .template-icon {
    float: left;
    font-size: 2em;
    margin-right: 0.5em;
    margin-top: 0.15em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .template-description {
    margin-bottom: 0;
  }
</style>
